export const defaultRowsPerPage = 10;
export const defaultPage = 1;
export const dataPerRequest = 10;
export const pageNumberLimit = 5;

export const fiscalSessionTypes = [
  { id: 1, name: "AD" },
  { id: 2, name: "BS" },
];
export const obTypes = [{ name: "DR" }, { name: "CR" }];

export const genders = [
  { id: "male", name: "MALE" },
  { id: "female", name: "FEMALE" },
  { id: "other", name: "OTHER" },
];
export const isEnable = [
  { id: true, name: "YES" },
  { id: false, name: "NO" },
];

export const costingMethods = [
  { id: "fifo", name: "FIFO" },
  { id: "lifo", name: "LIFO" },
  { id: "average", name: "AVERAGE" },
];

export const marketValuationMethods = [
  { id: "zero_price", name: "ZERO PRICE" },
  { id: "average_price", name: "AVERAGE PRICE" },
  { id: "last_sales_price", name: "LAST SALES PRICE" },
  { id: "standard_price", name: "STANDARD PRICE" },
];

export const typeOfLedgers = [
  { id: "accounts_payable", name: "Accounts Payable" },
  { id: "accounts_receivable", name: "Accounts Receivable" },
  { id: "general_ledger", name: "General Ledger" },
  { id: "inventory_ledger", name: "Inventory Ledger" },
];
export const partyTypes = [
  { id: "customer", name: "Customer" },
  { id: "supplier", name: "Supplier" },
  { id: "branch_customer", name: "Branch Customer" },
  { id: "branch_supplier", name: "Branch Supplier" },
];
export const groups = [
  { id: "sundary_payable", name: "Sundary Payable" },
  { id: "sundary_receivable", name: "Sundary Receivable" },
];
export const debtorOrCreditorTypes = [
  { id: "debtor", name: "Debtor" },
  { id: "creditor", name: "Creditor" },
];

export const additionalCostsInventory = [
  { id: "quantity", name: "Quantity" },
  { id: "amount", name: "Amount" },
];

export const appropriateToDatas = [
  { id: "goods", name: "Goods" },
  { id: "services", name: "Services" },
  { id: "both", name: "Both" },
];
export const signs = [{ name: "+" }, { name: "-" }];

export const typeOfIncomesExpenses = [
  { id: "sales_revenue", name: "Sales Revenue" },
  { id: "interest_income", name: "Interest Income" },
  { id: "operating_expenses", name: "Operating Expenses" },
  { id: "interest_expense", name: "Interest Expense" },
  { id: "inventory_purchases", name: "Inventory Purchases" },
  { id: "depreciation", name: "Depreciation" },
];

export const documentTypes = [
  { id: "citizenship", name: "Citizenship" },
  { id: "pan_certificate", name: "Pan Certificate" },
  { id: "company_registration", name: "Company Registration" },
  { id: "tax_clearance", name: "Tax Clearance" },
  { id: "audit_report", name: "Audit Report" },
  { id: "others", name: "Others" },
];

export const deliveryStatuses = [
  { name: "Pending", value: "PENDING" },
  { name: "In Transit", value: "IN_TRANSIT" },
  { name: "Delivered", value: "DELIVERED" },
  { name: "Delayed", value: "DELAYED" },
  { name: "Cancelled", value: "CANCELLED" },
];

export const exciseOnType = [
  { name: "Amount", id: "amount" },
  { name: "Quantity", id: "quantity" },
];
export const vatRateType = [
  { name: "0", id: "0.0000" },
  { name: "13%", id: "13.0000" },
];

export const hideButton = ["organization", "organizationHierarchy"];

export const paymentTypes = [
  { id: "bank", name: "BANK" },
  { id: "cash", name: "CASH" },
  { id: "cheque", name: "CHEQUE" },
  { id: "wallet", name: "WALLET" },
];

// for filters
export const purchaseOrderFilterStatus = [
  { name: "Pending", value: "PENDING" },
  { name: "Received", value: "RECEIVED" },
  { name: "Cancelled", value: "CANCELLED" },
];

export const accountTypes = [
  { id: "asset", name: "ASSET" },
  { id: "liability", name: "LIABILITY" },
  { id: "income", name: "INCOME" },
  { id: "expense", name: "EXPENSE" },
  { id: "equity", name: "EQUITY" },
];

export const filterDates = [
  { name: "Today", value: 1 },
  { name: "Yesterday", value: 2 },
  { name: "Week", value: 7 },
  { name: "Two weeks", value: 14 },
  { name: "Three weeks", value: 21 },
  { name: "One month", value: 30 },
];
export const voucherTypes = [
  {
    id: 1,
    name: "HO-ReceiptNoteAdditional Invoice",
  },
  {
    id: 2,
    name: "BTB-ReceiptNoteAdditional Invoice",
  },
];

export const creditType = [
  { name: "Allow", id: "allow" },
  { name: "Warning", id: "warning" },
  { name: "Blocked", id: "blocked" },
];
export const transactionTypes = [
  { name: "Purchase Order", id: "purchase_order" },
  { name: "Purchase Invoice", id: "purchase_invoice" },
  { name: "Purchase Return", id: "purchase_return" },
  { name: "Grn", id: "grn" },
  { name: "Grn Additional Invoice", id: "grn_additional_invoice" },
  { name: "Sales Order", id: "sales_order" },
  { name: "Sale Invoice", id: "sales_invoice" },
  { name: "Delivery Note", id: "delivery_note" },
  { name: "Sales Return", id: "sales_return" },
  { name: "Sales Debit Note", id: "sales_debit_note" },
  { name: "Inter-Branch Sales Invoice", id: "inter_branch_sales_invoice" },
  { name: "Inter-Branch Sales Order", id: "inter_branch_sales_order" },
];

export const accountVoucherTypes = [
  { id: "purchase", name: "Purchase Voucher" },
  { id: "purchase_return", name: "Purchase Return Voucher" },
  { id: "grn", name: "GRN Voucher" },
  { id: "grn_additional_invoice", name: "GRN Additional Invoice Voucher" },
  { id: "sale", name: "Sale Voucher" },
  { id: "delivery_notes", name: "Delivery Notes Voucher" },
  { id: "sale_return", name: "Sale Return Voucher" },
  { id: "journal", name: "Journal Voucher" },
  { id: "opening_balance", name: "Opening Balance Voucher" },
  { id: "receipt", name: "Receipt Voucher" },
  { id: "payment", name: "Payment Voucher" },
];

export const documentSeriesTypes = [
  { id: "por", name: "Purchase Order Request" },
  { id: "po", name: "Purchase Order" },
  { id: "grn", name: "Good Receipt Notes" },
  { id: "pi", name: "Purchase Invoice" },
  { id: "pore", name: "Purchase Order Return" },
  { id: "so", name: "Sales Order" },
  { id: "sor", name: "Sales Order Request" },
  { id: "dn", name: "Delivery Notes" },
  { id: "si", name: "Sales Invoice" },
  { id: "sore", name: "Sales Order Return" },
  { id: "grn_additional_invoice", name: "GRN Additional Invoice" },
  { id: "product", name: "Product" },
  { id: "purchase_debit_note", name: "Purchase Debit" },
  { id: "purchase_credit_note", name: "Purchase Credit" },
  { id: "sales_debit_note", name: "Sales Debit" },
  { id: "sales_credit_note", name: "Sales Credit" },
  { id: "grn_additional_invoice_cost", name: "GRN Additional Invoice Cost" },
  { id: "currency", name: "Currency" },
  { id: "freight_type", name: "Freight Type" },
  { id: "additional_charge", name: "Additional Charge" },
  { id: "cost_center_dimension", name: "Cost Center Dimension" },
  { id: "cost_center", name: "Cost Center" },
  { id: "cost_center_types", name: "Cost Center Types" },
  { id: "department", name: "Department" },
  { id: "party", name: "Party" },
  { id: "product_group", name: "Product Group" },
  { id: "customer", name: "Customer" },
];

export const itemTabs = [
  {
    tabName: "Basic Info",
    keyWord: "basic-info",
    ordering: 0,
    validateForm: "", // your existing key
    fields: ["name", "code", "baseUnit", "group", "harmonicCode", "category"], // Add the rest as needed
  },
  {
    tabName: "Additional Details",
    keyWord: "additional-details",
    ordering: 1,
    validateForm: "",
    fields: [], // etc
  },
  {
    tabName: "Product Costing",
    keyWord: "product-costing",
    ordering: 2,
    validateForm: "",
    fields: ["productCosting.costingMethod"],
  },
  {
    tabName: "Term Condition For Invoice",
    keyWord: "term-condition",
    ordering: 3,
    validateForm: "",
    fields: [],
  },
  {
    tabName: "Prefered Supplier",
    keyWord: "prefered-supplier",
    ordering: 4,
    validateForm: "preferedSupplier",
    fields: [],
  },
];

export const customerTabs = [
  {
    tabName: "Basic Info",
    ordering: 0,
    keyWord: "basicInfo",
    validateForm: "",
    fields: ["name", "code", "panVatNo", "mobileNo", "paymentType", "customerType"],
  },
  {
    tabName: "Contact Details",
    ordering: 1,
    keyWord: "contactDetails",
    validateForm: "contactDetails",
    fields: [
      "customerMasterContactDetails.name",
      "customerMasterContactDetails.designation",
      "customerMasterContactDetails.address",
      "customerMasterContactDetails.email",
      "customerMasterContactDetails.citizenshipNumber",
      "customerMasterContactDetails.mobileNumber1",
      "customerMasterContactDetails.telephoneNumber1",
    ],
  },
  {
    tabName: "Bill To Details",
    ordering: 2,
    keyWord: "billToDetails",
    validateForm: "billToDetails",
    fields: [
      "billToDetailsCustomerMaster.addressId",
      "billToDetailsCustomerMaster.fullAddress",
      "billToDetailsCustomerMaster.province",
      "billToDetailsCustomerMaster.district",
      "billToDetailsCustomerMaster.palika",
      "billToDetailsCustomerMaster.wardNumber",
    ],
  },
  {
    tabName: "Ship To Details",
    ordering: 3,
    keyWord: "shipToDetails",
    validateForm: "shipToDetails",
    fields: [
      "shipToDetails.addressId",
      "shipToDetails.fullAddress",
      "shipToDetails.province",
      "shipToDetails.district",
      "shipToDetails.palika",
      "shipToDetails.wardNumber",
    ],
  },
  {
    tabName: "Other Details",
    ordering: 4,
    keyWord: "otherDetails",
    validateForm: "",
    fields: ["additionalCostOnTheBasisOfInventory"], // No required fields
  },
  {
    tabName: "Doc. Attach",
    ordering: 5,
    keyWord: "customerMasterDocuments",
    validateForm: "customerMasterDocuments",
    fields: ["customerMasterDocuments.documentType", "customerMasterDocuments.document"],
  },
];

export const supplierTabs = [
  {
    tabName: "Basic Info",
    keyWord: "basicInfo",
    ordering: 0,
    validateForm: "", // your existing key
    fields: ["name", "alias", "code", "creditAs", "currency", "duesFrom", "debtorOrCreditorType"], // Add the rest as needed
  },
  {
    tabName: "Contact Details",
    keyWord: "contactDetails",
    ordering: 1,
    validateForm: "contactDetails",
    fields: ["contacts.name", "contacts.designation", "contacts.email", "contacts.mobile1", "contacts.tel1"], // etc
  },
  {
    tabName: "Other Details",
    keyWord: "otherDetails",
    ordering: 2,
    validateForm: "",
    fields: [
      "otherDetails.bankName",
      "otherDetails.appropriateTo",
      "otherDetails.additionalCostInventory",
      "partyType",
    ],
  },
  {
    tabName: "Doc. Attach",
    keyWord: "docAttachments",
    ordering: 3,
    validateForm: "docAttachments",
    fields: ["docAttachments.documentType", "docAttachments.attachDocument"],
  },
];

export const purchaseFromBranchTabs = [
  {
    tabName: "FromBranch",
    ordering: 0,
    keyWord: "purchase-from-branch",
  },
];
export const purchaseOrderTabs = [
  {
    tabName: "Create",
    ordering: 0,
    keyWord: "create",
  },
];

export const purchaseReturnTabs = [
  {
    tabName: "Purchase Return",
    ordering: 0,
    keyWord: "purchase-return",
  },
];

export const materialRequestsFrom = [
  { id: true, name: "HO" },
  { id: false, name: "BRANCH" },
];
export const saleQuotationTabs = [
  {
    tabName: "Sale Quotation",
    ordering: 0,
    keyWord: "sale-quotation",
  },
];

export const saleQuotationsFrom = [
  { id: "true", name: "HO" },
  { id: "false", name: "BRANCH" },
];

export const saleOrderTabs = [
  {
    tabName: "View",
    ordering: 0,
    keyWord: "view",
  },
  {
    tabName: "Edit",
    ordering: 0,
    keyWord: "edit",
  },
];
export const saleReturnTabs = [
  {
    tabName: "View",
    ordering: 0,
    keyWord: "view",
  },
];
export const saleTabs = [
  {
    tabName: "View",
    ordering: 0,
    keyWord: "view",
  },
];

//view and create for materialRequest,purchaseInvoice,purchaseInvoiceBranch,purchaseDebitNote,purchaseCreditNote,saleOrderRequest,saleOrder,saleInvoiceBranch,saleInvoice,grn,grnInvoice,deliveryNote,saleDebitNote,saleCreditNote
export const getViewCreateTabs = [
  { tabName: "View", ordering: 0, keyWord: "view" },
  { tabName: "Create", ordering: 1, keyWord: "create" },
];
